/* Collection V3 + Search V3 (round 2 item 12, Strategy/2026-10/collection-v3/Spec-2026-10-03.md). Collection and search
   templates only. Every selector is scoped to .sp3-* or [data-sp-coll] (nav-v3 lesson 6b8aa94).
   - Filters: one form. Sidebar (1025px+): live apply on tick (ruling D11). Sheet / panel: batch apply with a live
     "Show N" (server count for the pending filters, scoped to the saved bike when known-fit offers kf.count).
   - Every change (apply, pill remove, Clear all, promoted chip, sort) swaps #CollectionAjaxContent by Section
     Rendering and pushes the URL, so Back and Forward work. Known-fit re-scopes on the swap (its observer, plus
     'sp:collection-updated' on [data-sp-kf-scope]). Dealers: SP.repriceDealer on swapped and appended cards.
   - Saved-bike chips from known-fit's sp:kf-scoped event; a tap selects only that bike, a second tap shows all.
   - Platform split + sound ladder; search bike shortcut row from the vocab; sold-out results sink in search (D6).
   No /cart.js calls here. */
(function () {
  'use strict';
  var d = document, html = d.documentElement;
  html.classList.add('sp3-js');
  var MQ = window.matchMedia('(max-width: 1024px)');
  var TICK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function root() { return d.querySelector('.sp3-coll[data-sp-coll]'); }
  function surface() { var r = root(); return (r && r.getAttribute('data-sp-surface')) || 'collection'; }
  function scope() { return d.querySelector('.sp3-coll [data-sp-kf-scope]'); }
  function filtersEl() { return d.querySelector('.sp3-coll .sp3-filters[data-sp-filters]'); }
  function form() { return d.querySelector('.sp3-coll form[data-sp-filter-form]'); }
  function publish(name, data) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {} }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function reprice(el) { try { if (window.SP && SP.repriceDealer) SP.repriceDealer(el); } catch (e) {} }

  /* ---------------------------------------------------------------- URLs and Section Rendering */
  function params(f) {
    var p = new URLSearchParams();
    new FormData(f).forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
    return p;
  }
  function filterKey(p) {
    var out = [];
    p.forEach(function (v, k) { if (k.indexOf('filter.') === 0) out.push(k + '=' + v); });
    return out.sort();
  }
  function withSection(url) {
    var r = root(), u = new URL(url, location.origin);
    u.searchParams.set('section_id', r.getAttribute('data-section-id'));
    u.searchParams.delete('page');
    return u.toString();
  }
  function clean(url) { var u = new URL(url, location.origin); u.searchParams.delete('section_id'); return u.pathname + (u.search || ''); }
  var cache = {};
  function getSection(url) {
    var key = withSection(url);
    if (!cache[key]) {
      cache[key] = fetch(key, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('section ' + r.status); return r.text(); });
      cache[key].catch(function () { delete cache[key]; });
    }
    return cache[key];
  }
  function frag(text) { var t = d.createElement('template'); t.innerHTML = text; return t.content; }

  /* ---------------------------------------------------------------- swap */
  var swapRun = 0;
  function swapTo(url, opts) {
    opts = opts || {};
    var r = root();
    if (!r || !d.getElementById('CollectionAjaxContent')) { location.href = url; return; }
    var run = ++swapRun;
    r.classList.add('is-loading');
    r.setAttribute('aria-busy', 'true');
    return getSection(url).then(function (text) {
      if (run !== swapRun) return;
      var next = frag(text).querySelector('#CollectionAjaxContent');
      var cur = d.getElementById('CollectionAjaxContent');
      if (!next || !cur) { location.href = clean(url); return; }
      closeSheet(true);
      var focusSel = focusKey(cur);
      cur.innerHTML = next.innerHTML;
      if (opts.push !== false) history.pushState({ sp3: 1 }, '', clean(url));
      afterSwap(cur);
      if (focusSel) refocus(cur, focusSel);
      if (opts.why) publish('collection_filter_apply', { surface: surface(), why: opts.why, filters: filterKey(new URL(url, location.origin).searchParams), path: location.pathname });
    }).catch(function () { location.href = clean(url); }).then(function () {
      if (run !== swapRun) return;
      r.classList.remove('is-loading');
      r.removeAttribute('aria-busy');
    });
  }
  /* Focus survives the swap (WDG review 2026-10-05; same idea as sp-cart-drawer.js render): the swap replaces the
     filter inputs and the Filter button, so remember the focused control by a stable selector and focus its
     replacement: the same filter input at 1440, the Filter button after the sheet closes at 390. */
  function focusKey(cur) {
    var a = d.activeElement;
    if (!a || !cur.contains(a)) return null;
    if (a.matches('input[name]')) return 'input[name="' + CSS.escape(a.name) + '"][value="' + CSS.escape(a.value) + '"]';
    if (a.matches('select[data-sp-sort]')) return 'select[data-sp-sort]';
    if (a.matches('button[data-sp-filter-open]')) return 'button[data-sp-filter-open]';
    if (a.id) return '#' + CSS.escape(a.id);
    return '*';
  }
  function refocus(cur, sel) {
    var shown = function (el) { return el && el.getClientRects().length > 0; };
    var el = sel !== '*' ? cur.querySelector(sel) : null;
    if (!shown(el)) el = cur.querySelector('button[data-sp-filter-open]');
    if (!shown(el)) { el = cur.querySelector('[data-sp-grid]'); if (el) el.setAttribute('tabindex', '-1'); }
    if (el) el.focus({ preventScroll: true });
  }
  function afterSwap(cur) {
    setSheetMode();
    syncPromoted();
    sinkSoldOut();
    reprice(cur);
    var sc = scope();
    if (sc) { try { sc.dispatchEvent(new CustomEvent('sp:collection-updated', { bubbles: true })); } catch (e) {} }
    if (lastKf) renderBikes(lastKf);
    var top = sc ? sc.getBoundingClientRect().top : 0;
    if (top < 0) window.scrollBy({ top: top - 72, behavior: 'smooth' });
  }
  window.addEventListener('popstate', function (e) { if (e.state && e.state.sp3) swapTo(location.href, { push: false }); });
  try { history.replaceState({ sp3: 1 }, '', location.href); } catch (e) {}

  /* promoted chips in the head (Sound on muffler lists) follow the applied filters */
  function syncPromoted() {
    var f = form();
    var row = d.querySelector('.sp3-coll-head .sp3-row[data-sp-promoted]');
    if (!row) return;
    var on = {};
    if (f) params(f).forEach(function (v, k) { on[k + '=' + v] = 1; });
    row.querySelectorAll('a.sp3-chip[data-sp-filter-chip]').forEach(function (a) {
      var key = a.getAttribute('data-name') + '=' + a.getAttribute('data-value');
      var active = !!on[key];
      a.classList.toggle('is-on', active);
      a.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (f) {
        var inp = f.querySelector('input[name="' + a.getAttribute('data-name') + '"][value="' + CSS.escape(a.getAttribute('data-value')) + '"]');
        var n = inp && inp.closest('label') && inp.closest('label').querySelector('[data-sp-count]');
        var cn = a.querySelector('[data-sp-count]');
        if (n && cn) cn.textContent = n.textContent;
      }
    });
  }

  /* ---------------------------------------------------------------- sheet / panel */
  var snapshot = '', opener = null, scrim = null;
  function setSheetMode() {
    var f = filtersEl();
    if (!f) return;
    var sheet = MQ.matches || f.hasAttribute('data-panel');
    f.classList.toggle('is-sheet', sheet);
    if (sheet) { f.setAttribute('role', 'dialog'); f.setAttribute('aria-modal', 'true'); }
    else { f.removeAttribute('role'); f.removeAttribute('aria-modal'); f.classList.remove('is-open'); unlock(); }
  }
  if (MQ.addEventListener) MQ.addEventListener('change', setSheetMode);
  function ensureScrim() {
    if (scrim) return scrim;
    scrim = d.createElement('div');
    scrim.className = 'sp3-scrim';
    scrim.setAttribute('data-sp3-scrim', '');
    d.body.appendChild(scrim);
    scrim.addEventListener('click', function () { closeSheet(false); });
    return scrim;
  }
  function unlock() { html.classList.remove('sp3-sheet-open'); if (scrim) scrim.classList.remove('is-open'); }
  function openSheet(btn) {
    var f = filtersEl(), fm = form();
    if (!f || !fm) return;
    setSheetMode();
    if (!f.classList.contains('is-sheet')) { f.scrollIntoView({ block: 'start' }); return; }
    snapshot = params(fm).toString();
    opener = btn || null;
    ensureScrim().classList.add('is-open');
    f.classList.add('is-open');
    html.classList.add('sp3-sheet-open');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    setPending(fm);
    var x = f.querySelector('button.sp3-filters__x');
    setTimeout(function () { if (x) x.focus(); }, 30);
  }
  function restore(fm, qs) {
    var p = new URLSearchParams(qs), on = {};
    p.forEach(function (v, k) { (on[k] = on[k] || []).push(v); });
    fm.querySelectorAll('input').forEach(function (i) {
      if (i.type === 'checkbox') i.checked = !!(on[i.name] && on[i.name].indexOf(i.value) > -1);
      else if (i.type === 'number') i.value = (on[i.name] && on[i.name][0]) || '';
    });
  }
  function closeSheet(applied) {
    var f = filtersEl(), fm = form();
    if (!f || !f.classList.contains('is-open')) { unlock(); return; }
    if (!applied && fm) restore(fm, snapshot);
    f.classList.remove('is-open');
    unlock();
    var btn = opener && d.contains(opener) ? opener : d.querySelector('.sp3-coll button[data-sp-filter-open]');
    if (btn) { btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
    opener = null;
  }
  d.addEventListener('keydown', function (e) {
    var f = filtersEl();
    if (!f || !f.classList.contains('is-open')) return;
    if (e.key === 'Escape') { e.preventDefault(); closeSheet(false); return; }
    if (e.key !== 'Tab') return;
    var list = Array.prototype.filter.call(f.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select'), function (el) { return el.offsetParent !== null || el.type === 'checkbox'; });
    if (!list.length) return;
    var first = list[0], last = list[list.length - 1];
    if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    else if (!f.contains(d.activeElement)) { e.preventDefault(); first.focus(); }
  });

  /* pending state inside the sheet: change count, live Show N, option counts for the pending filters */
  var pendT = null, pendRun = 0;
  function noun(fm, n) {
    var w = fm.getAttribute('data-noun') || 'products';
    return n === 1 ? w.replace(/s$/, '') : w;
  }
  function setPending(fm) {
    var now = params(fm), was = new URLSearchParams(snapshot);
    var a = filterKey(now), b = filterKey(was);
    var diff = a.filter(function (x) { return b.indexOf(x) < 0; }).length + b.filter(function (x) { return a.indexOf(x) < 0; }).length;
    var pend = fm.querySelector('[data-sp-pending]');
    if (pend) pend.textContent = diff ? diff + (diff === 1 ? ' change' : ' changes') + ' not applied' : '';
    clearTimeout(pendT);
    var show = fm.querySelector('button[data-sp-filter-show]');
    if (!diff) { if (show) { show.disabled = false; show.textContent = 'Show ' + (fm.getAttribute('data-total') || '') + ' ' + noun(fm, +fm.getAttribute('data-total')); } return; }
    var run = ++pendRun;
    pendT = setTimeout(function () {
      var url = fm.getAttribute('action') + '?' + now.toString();
      getSection(url).then(function (text) {
        if (run !== pendRun) return;
        var fr = frag(text);
        var r = fr.querySelector('.sp3-coll[data-sp-coll]');
        var n = r ? +r.getAttribute('data-sp-now') : NaN;
        var handles = Array.prototype.map.call(fr.querySelectorAll('[data-sp-grid] > .sp-card-item'), function (c) { return c.getAttribute('data-product-handle'); });
        var pg = fr.querySelector('[data-sp-kf-pages]'), pages = pg ? +pg.getAttribute('data-sp-kf-pages') : 1;
        try { if (pages <= 1 && window.SP && SP.Garage && SP.Garage.kf && SP.Garage.kf.count) n = SP.Garage.kf.count(surface(), handles); } catch (e) {}
        if (show && !isNaN(n)) { show.textContent = 'Show ' + n + ' ' + noun(fm, n); show.disabled = n === 0; }
        fr.querySelectorAll('form[data-sp-filter-form] input[type="checkbox"]').forEach(function (inp) {
          var mine = fm.querySelector('input[type="checkbox"][name="' + inp.name + '"][value="' + CSS.escape(inp.value) + '"]');
          var src = inp.closest('label') && inp.closest('label').querySelector('[data-sp-count]');
          var dst = mine && mine.closest('label');
          if (!dst || !src) return;
          var c = dst.querySelector('[data-sp-count]');
          if (c) c.textContent = src.textContent;
          var zero = +src.textContent === 0 && !mine.checked;
          dst.classList.toggle('is-zero', zero);
          if (zero) mine.setAttribute('aria-disabled', 'true'); else mine.removeAttribute('aria-disabled');
        });
      }).catch(function () {});
    }, 250);
  }

  d.addEventListener('change', function (e) {
    var t = e.target;
    var fm = t && t.closest && t.closest('.sp3-coll form[data-sp-filter-form]');
    if (fm) {
      if (t.type === 'checkbox' && t.checked && t.getAttribute('aria-disabled') === 'true') { t.checked = false; return; }
      var f = filtersEl();
      if (f && f.classList.contains('is-sheet')) setPending(fm);
      else swapTo(fm.getAttribute('action') + '?' + params(fm).toString(), { why: 'live' });
      return;
    }
    var sel = t && t.matches && t.matches('.sp3-coll select[data-sp-sort]') ? t : null;
    if (sel) {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      var lab = sel.closest('label') && sel.closest('label').querySelector('[data-sp-sort-label]');
      if (lab) lab.textContent = sel.options[sel.selectedIndex].text;
      publish('collection_sort', { surface: surface(), sort: sel.value });
      swapTo(u.toString());
    }
  });
  d.addEventListener('submit', function (e) {
    var fm = e.target;
    if (!fm || !fm.matches || !fm.matches('.sp3-coll form[data-sp-filter-form]')) return;
    e.preventDefault();
    swapTo(fm.getAttribute('action') + '?' + params(fm).toString(), { why: 'sheet' });
  });

  /* Sound chips are links (no-JS and crawlers still filter) with role=button and aria-pressed, so Space must act like
     Enter instead of scrolling the page (WDG Liquid review 2026-10-05). */
  d.addEventListener('keydown', function (e) {
    if (e.key !== ' ' && e.key !== 'Spacebar') return;
    var a = e.target.closest && e.target.closest('.sp3-coll-head a[data-sp-filter-chip][role="button"]');
    if (!a) return;
    e.preventDefault();
    a.click();
  });

  /* ---------------------------------------------------------------- clicks */
  d.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('button, a');
    if (!t) return;
    if (t.matches('.sp3-coll button[data-sp-filter-open]')) { e.preventDefault(); openSheet(t); return; }
    if (t.matches('.sp3-coll button[data-sp-filter-close]')) { e.preventDefault(); closeSheet(false); return; }
    if (t.matches('.sp3-coll a[data-sp-remove], .sp3-coll a[data-sp-filter-clear], .sp3-coll-head a[data-sp-filter-chip]')) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      swapTo(t.href, { why: t.hasAttribute('data-sp-filter-chip') ? 'promoted' : 'remove' });
      return;
    }
    if (t.matches('.sp3-coll a[data-sp-more-btn]')) { e.preventDefault(); loadMore(t); return; }
    if (t.matches('.sp3-coll button[data-sp3-bike]')) { e.preventDefault(); pickBike(t.getAttribute('data-sp3-bike')); return; }
    if (t.matches('.sp3-coll-head button[data-sp-split]')) { e.preventDefault(); pickSplit(t.getAttribute('data-sp-split'), true); return; }
    if (t.matches('.sp3-coll-head a.sp3-step')) { publish('collection_ladder_click', { profile: t.getAttribute('data-sp-step'), path: location.pathname }); }
  });

  /* ---------------------------------------------------------------- load more (past 48) */
  function loadMore(btn) {
    var grid = d.querySelector('.sp3-coll [data-sp-grid]');
    if (!grid) { location.href = btn.href; return; }
    btn.setAttribute('aria-busy', 'true');
    btn.textContent = 'Loading...';
    var mu = new URL(btn.href, location.origin);
    mu.searchParams.set('section_id', root().getAttribute('data-section-id'));
    fetch(mu.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (text) {
        var fr = frag(text);
        var cards = fr.querySelectorAll('[data-sp-grid] > .sp-card-item');
        var added = [];
        cards.forEach(function (c) { var n = d.importNode(c, true); grid.appendChild(n); added.push(n); });
        var more = d.querySelector('.sp3-coll [data-sp-more]'), nextMore = fr.querySelector('[data-sp-more]');
        if (more && nextMore) more.replaceWith(d.importNode(nextMore, true));
        var pag = d.querySelector('.sp3-coll .pagination'), nextPag = fr.querySelector('.pagination');
        if (pag && nextPag) pag.replaceWith(d.importNode(nextPag, true));
        reprice(grid);
        if (added[0]) { var a = added[0].querySelector('a.sp-card__name'); if (a) a.focus({ preventScroll: true }); }
        publish('collection_load_more', { surface: surface(), added: added.length });
      })
      .catch(function () { location.href = btn.href; });
  }

  /* ---------------------------------------------------------------- saved-bike chips (known-fit) */
  var lastKf = null;
  function renderBikes(det) {
    var box = d.querySelector('.sp3-coll [data-sp-bikes]');
    var row = box && box.closest('[data-sp-applied]');
    if (!box || !row) return;
    var bikes = det.bikes || [];
    /* One saved bike: the fit bar names it and a lone chip would toggle nothing, so chips start at two bikes */
    var show = det.mode && det.mode !== 'none' && bikes.length > 1;
    box.hidden = !show;
    row.classList.toggle('has-bikes', show);
    var div = row.querySelector('[data-sp-div]');
    if (div) div.hidden = !(show && row.querySelector('a[data-sp-remove]'));
    if (!show) { box.innerHTML = ''; return; }
    box.innerHTML = bikes.map(function (b) {
      var on = det.selected === b.id;
      return '<button type="button" class="sp3-chip sp3-chip--bike' + (on ? ' is-on' : '') + (b.count ? '' : ' sp3-chip--zero') + '" aria-pressed="' + on + '" data-sp3-bike="' + esc(b.id) + '">' +
        (b.count ? TICK : '') + esc(String(b.label || '').replace(/\s*\([^)]*\)\s*$/, '')) + ' <small>' + b.count + '</small><span class="visually-hidden"> ' + (b.count === 1 ? 'part fits' : 'parts fit') + '</span></button>';
    }).join('') + '<button type="button" class="sp3-chip sp3-chip--add" data-sp-garage-open>+ Add a bike</button>';
    var more = d.querySelector('.sp3-coll [data-sp-more]');
    if (more) more.hidden = det.mode === 'fit' || det.mode === 'header';
  }
  function pickBike(id) {
    if (!(window.SP && SP.Garage && SP.Garage.kf)) return;
    var st = SP.Garage.kf.state(surface()) || {};
    SP.Garage.kf.select(surface(), st.selected === id ? null : id);
    publish('collection_bike_chip', { surface: surface(), selected: st.selected === id ? null : id });
  }
  d.addEventListener('sp:kf-scoped', function (e) {
    var det = e.detail || {};
    if (det.surface !== surface()) return;
    lastKf = det;
    renderBikes(det);
  });

  /* ---------------------------------------------------------------- platform split + ladder */
  function vocab() { return window.SP_GARAGE_VOCAB || null; }
  function eachGen(fn) {
    var V = vocab();
    if (!V) return;
    (V.makes || []).forEach(function (m) { (m.families || []).forEach(function (f) { (f.generations || []).forEach(function (g) { fn(g, f, m); }); }); });
  }
  function genFor(handle) { var hit = null; eachGen(function (g) { if (!hit && (g.systems || []).indexOf(handle) > -1) hit = g; }); return hit; }
  function bikeName(b) { return b.label || (b.year + ' ' + (b.nickname || b.genLabel || '')); }
  function pickSplit(handle, byUser) {
    var wrap = d.querySelector('.sp3-coll-head [data-sp-coll-ladder]');
    if (!wrap) return;
    wrap.querySelectorAll('button[data-sp-split]').forEach(function (b) {
      var on = b.getAttribute('data-sp-split') === handle;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var lads = wrap.querySelectorAll('ul[data-sp-ladder]');
    var target = wrap.querySelector('ul[data-sp-ladder="' + CSS.escape(handle) + '"]');
    if (target) lads.forEach(function (u) { u.hidden = u !== target; });
    d.querySelectorAll('.sp3-coll [data-sp-grid] > .sp-card-item').forEach(function (c) { c.classList.toggle('is-picked', byUser && c.getAttribute('data-product-handle') === handle); });
    if (byUser) publish('collection_split_select', { handle: handle, path: location.pathname });
  }
  function initLadder() {
    var wrap = d.querySelector('.sp3-coll-head [data-sp-coll-ladder]');
    if (!wrap) return;
    wrap.querySelectorAll('span[data-sp-engine]').forEach(function (s) {
      var g = genFor(s.getAttribute('data-sp-engine'));
      if (g && g.engine) s.textContent = g.engine.split(' / ')[0].replace(/ \d+$/, '');
    });
    var bikes = (window.SP && SP.Garage && SP.Garage.list) ? SP.Garage.list() : [];
    var act = (window.SP && SP.Garage && SP.Garage.active) ? SP.Garage.active() : null;
    var pick = null, mineAny = false;
    wrap.querySelectorAll('button[data-sp-split]').forEach(function (b) {
      var h = b.getAttribute('data-sp-split'), g = genFor(h);
      var mine = g ? bikes.filter(function (x) { return x.genId === g.id; }) : [];
      var y = b.querySelector('[data-sp-yours]');
      if (y) {
        y.hidden = !mine.length;
        y.innerHTML = mine.length ? TICK + 'Your ' + esc(bikeName(mine[0])) : '';
      }
      if (mine.length) { mineAny = true; if (!pick || (act && mine.indexOf(act) > -1)) pick = h; }
    });
    var hint = wrap.querySelector('[data-sp-split-hint]');
    if (hint) hint.hidden = mineAny;
    if (pick) pickSplit(pick, false);
  }
  d.addEventListener('sp:garage-change', initLadder);

  /* ---------------------------------------------------------------- search: bike shortcut + sold out last */
  function initShortcut() {
    var box = d.querySelector('.sp3-coll-head [data-sp-shortcut]');
    if (!box) return;
    var q = (box.getAttribute('data-q') || '').toLowerCase().replace(/[^a-z0-9 /]/g, ' ').replace(/\s+/g, ' ').trim();
    if (!q || !vocab()) { box.hidden = true; return; }
    var ym = q.match(/\b(19[89]\d|20[0-3]\d)\b/);
    var year = ym ? +ym[1] : null;
    /* Generation aliases (model names such as "street bob", which cross families by year) come first, then family names.
       Aliases live in snippets/garage-vocab.liquid (known-fit's file): g.aliases / f.aliases. */
    function hit(n) { var p = String(n).toLowerCase().trim(); return p && new RegExp('(^| )' + p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '( |$)').test(q); }
    var cand = [], famOf = {};
    eachGen(function (g, f) { famOf[g.id] = f; if ((g.aliases || []).some(hit)) cand.push(g); });
    if (!cand.length) eachGen(function (g, f) { if ([f.name].concat(f.aliases || []).some(function (n) { return String(n).split(' / ').some(hit); })) cand.push(g); });
    if (!cand.length) { box.hidden = true; return; }
    var gens = cand.filter(function (g) { return !year || (year >= g.years[0] && year <= g.years[1]); });
    if (!gens.length) { box.hidden = true; return; }
    var fam = famOf[gens[0].id], famName = fam.name.split(' / ')[0];
    var g = gens.length === 1 ? gens[0] : null;
    var multiFam = gens.some(function (x) { return famOf[x.id] !== fam; });
    var title = (year ? year + ' ' : '') + (multiFam ? q.replace(/\b\d{4}\b/, '').trim().replace(/\b\w/g, function (c) { return c.toUpperCase(); }) : famName);
    var saved = (window.SP && SP.Garage && SP.Garage.list) ? SP.Garage.list().filter(function (b) { return g && b.genId === g.id && (!year || b.year === year); })[0] : null;
    var href, line;
    if (g && g.systems && g.systems.length === 1) {
      href = '/products/' + g.systems[0];
      line = 'One system is built for it: the ' + g.years[0] + ' to ' + g.years[1] + ' ' + famName + '. Plus parts that fit.';
    } else if (g && g.slipons && g.slipons.length) {
      href = '/products/' + g.slipons[0];
      line = 'It takes the ' + famName + ' slip-on. Plus parts that fit.';
    } else if (!g && gens.length > 1) {
      href = '';
      line = 'The year decides the system: ' + gens.map(function (x) { return x.years[0] + ' to ' + x.years[1] + ' ' + x.label.replace(/\s*\([^)]*\)/, ''); }).join(', ') + '.';
    } else {
      href = '/collections/' + (g || gens[0]).collection;
      line = 'Systems and parts for the ' + famName + '.';
    }
    box.innerHTML = '<div class="sp3-shortcut__card"><div class="sp3-shortcut__t"><b>' + esc(saved ? 'Your ' + bikeName(saved) : title) + '</b><span>' + esc(line) + '</span>' +
      '<div class="sp3-shortcut__acts">' + (href ? '<a class="sp3-sec" href="' + esc(href) + '" data-sp3-shortcut-go>Shop for ' + (year ? 'my ' : 'the ') + esc(title) + '</a>' : '<button type="button" class="sp3-sec" data-sp-garage-open>Add your bike and year</button>') +
      (g && year && !saved ? '<button type="button" class="sp3-tert" data-sp3-shortcut-save>Save this bike</button>' : '') + '</div></div></div>';
    box.hidden = false;
    publish('search_bike_shortcut', { q: q, gen: g ? g.id : null, action: 'shown' });
    box.addEventListener('click', function (e) {
      var s = e.target.closest('button[data-sp3-shortcut-save]');
      if (s && window.SP && SP.Garage && SP.Garage.add) {
        SP.Garage.add({ genId: g.id, year: year });
        s.outerHTML = '<span class="sp3-shortcut__saved">Saved</span>';
        publish('search_bike_shortcut', { q: q, gen: g.id, action: 'save' });
      }
      if (e.target.closest('a[data-sp3-shortcut-go]')) publish('search_bike_shortcut', { q: q, gen: g ? g.id : null, action: 'shop' });
    });
  }
  function sinkSoldOut() {
    var grid = d.querySelector('.sp3-coll--search [data-sp-search-grid]');
    if (!grid) return;
    Array.prototype.filter.call(grid.children, function (c) { return c.getAttribute('data-sp-avail') === '0' && !c.hasAttribute('data-sp-kf-added'); })
      .forEach(function (c) { grid.appendChild(c); });
  }

  /* ---------------------------------------------------------------- init */
  setSheetMode();
  sinkSoldOut();
  /* stealth-garage.js (SP.Garage) loads after this file, so the bike-aware parts wait for DOMContentLoaded */
  function late() { initLadder(); initShortcut(); }
  if (d.readyState === 'complete') late(); else d.addEventListener('DOMContentLoaded', late);
  var af = d.querySelector('.sp3-coll-head input[data-sp-autofocus]');
  if (af && window.matchMedia('(min-width: 769px)').matches) af.focus({ preventScroll: true });
})();
